<template>
<div class="trash_view">
        <div class="menu">
            <div class="header">
                <div class="back-tip" @click="handleBack">
                    <img class="wiki-icon" src="@/assets/img/trash/wiki-back.svg"/>
                    <div class="header-title">{{$t("返回知识库")}}</div>
                </div>
                <!-- <img class="wiki-icon" src="@/assets/img/trash/wiki-menu.svg"> -->
            </div>
            <div class="wiki-info">
                <img class="wiki-space" src="@/assets/img/trash/wiki-space.svg"/>
                <Span> {{ wikiSpaceInfo.wikiSpaceName }}</Span>
            </div>
            <div class="wiki-trash">
                <img class="wiki-space" src="@/assets/img/trash/wiki-trash.svg"/>{{$t("回收站")}}            </div>
        </div>
        <div class="trash_content">
            <div class="toolbar">
                <div class="toolbar_left">
                    <!-- <img class="wiki-menu-open" src="@/assets/img/trash/wiki-menu-open.svg"> -->{{$t("回收站")}}                </div>
                <div class="toolbar_right">
                    <a-button @click="handerClean" class="wiki-button clear" type="primary">{{$t("清空")}}<img class="wiki-menu-open" src="@/assets/img/trash/wiki-button-clear.svg"/></a-button>
                    <a-button @click="handerRefresh" class="wiki-button refresh">{{$t("刷新")}}<img class="wiki-menu-open" src="@/assets/img/trash/wiki-button-refresh.svg"/></a-button>
                </div>
            </div>
            <a-spin v-if="data.length === 0" :loading="loading" :size="32">
                <div class="trash_empty">
                    <div>
                        <img src="../assets/img/trash/wiki-trash-empty.svg"/>
                        <div class="trash_empty_tip">{{$t("暂无内容")}}</div>
                    </div>
                </div>
            </a-spin>
            <div v-else class="table">
                <!-- <a-table :hoverable="false" class="wiki-table" :virtual-list-props="{ height: 650 }" :pagination="false"
            :columns="columns" :data="[...data, ...data, ...data, ...data, ...data, ...data, ...data, ...data, ...data,]"
            column-resizable :bordered="false">
            <template #optional="{ record }">
              <img :style="fileStyle" src="@/assets/img/trash/wiki-file.svg">
            </template>
<template #delete="{ record }">
              <options :record="record"></options>
            </template>
</a-table> -->

                <a-table @page-change="tablePageChange" :loading="loading" class="wiki-table" :hoverable="false" :columns="columns" :data="data" scrollbar :pagination="paginationProps" :bordered="false">
                    <template #optional="{ record }">
                        <img :style="fileStyle" :src="configFileIcon(record)"/>
                    </template>
                    <template #delete="{ record }">
                        <options :record="record" @load-data="loadData(currentPage)" @recover-file="recoverFile"></options> </template></a-table>
            </div>
        </div>
        <CommonDialog :show="showCleanTip" :title="$t('确认清空回收站吗？')" :content="$t('清空后文件将不可还原')" :cancelText="$t('取消')" :okText="$t('确定')" :handleCancel="handerCleanTipCancel" :handleOk="handerCleanTipOk"></CommonDialog>
    </div>
</template>

<script lang="ts">
import Options from '../components/trash/options.vue';
import CommonDialog from '../components/trash/commonDialog.vue';
import { mapActions, mapState, mapGetters } from 'vuex';
import { getRecycleList, deletRecycleList } from '../core/api/trashApi';
import wikiFileImg from '../assets/img/trash/wiki-file.svg';
import pptIcon from '../assets/img/trash/wiki-trash-ppt.svg';
import excelIcon from '../assets/img/trash/wiki-trash-excel.svg';
import fileIcon from '../assets/img/trash/wiki-trash-file.svg';
import { getBrowser } from '@/utils/browser';
import { useI18n, intl } from 'tci18n-vue3';

export default {
  name: 'test_view',
  components: {
    Options,
    CommonDialog },

  data() {
    return {
      loading: false,
      showCleanTip: false,
      tableHeight: 700,
      isRecover: false,
      data: [],
      columns: [
      {
        title: intl.$t("类型"),
        slotName: 'optional',
        width: 100,
        align: 'right' },

      {
        title: intl.$t("名称"),
        dataIndex: 'name',
        width: 320 },

      {
        title: intl.$t("所有者"),
        dataIndex: 'owner',
        width: 120 },

      {
        title: intl.$t("删除者"),
        dataIndex: 'deletedBy',
        width: 120 },

      {
        title: intl.$t("删除时间"),
        slotName: 'delete',
        dataIndex: 'salary' }],


      currentPage: 1,
      paginationProps: {
        pageSize: 9,
        total: 0,
        current: 1 } };


  },
  created() {
    this.loadData(1);
  },
  computed: {
    fileStyle() {
      return {
        width: '36px',
        height: '36px' };

    },
    ...mapState({
      wikiSpaceInfo: (state) => state.kbTreeNodeModule.wikiSpaceInfo }) },


  mounted() {
    let pageHeight =
    window.innerHeight ||
    document.documentElement.clientHeight ||
    document.body.clientHeight;
    this.tableHeight = pageHeight - 120;
  },
  methods: {
    ...mapActions({ setDocView: 'kbModule/setDocView' }),
    handleBack() {
      // this.$router.back();
      this.setDocView('home');
      //文件还原后主页目录不会刷新，暂时添加一个主动刷新
      if (this.isRecover) {
        this.isRecover = false;
        if (getBrowser().isInTocaApp === true) {
          window.open(window.location.href, '_self');
        } else {
          location.reload();
        }
      }
    },
    configFileIcon(fileInfo: any) {
      if (fileInfo.contentType) {
        if (fileInfo.contentType === 'PPT') {
          return pptIcon;
        } else if (fileInfo.contentType === 'DOCUMENT') {
          return fileIcon;
        } else if (fileInfo.contentType === 'EXCEL') {
          return excelIcon;
        }
      }
      return wikiFileImg;
    },
    recoverFile() {
      this.isRecover = true;
    },
    loadData(page: number) {
      this.paginationProps.current = page;
      this.loading = true;
      console.log('wikiSpaceId:');
      console.log(this.wikiSpaceInfo.wikiSpaceId);
      let since = (page - 1) * 9;
      getRecycleList(
      since.toString(),
      '9',
      this.wikiSpaceInfo.wikiSpaceId).
      then((result) => {
        this.loading = false;
        console.log('getRecycleList:');
        console.dir(result);
        let data = result.data.data;
        if (data) {
          this.paginationProps.total = data.pager.total;
          this.data = [];

          if (data.result.length > 0) {
            data.result.map((item) => {
              item['key'] = item.id;
              item['name'] = item.fileName;
              item['salary'] = this.timeStampToTime(
              item.createTime);

              let owner = '';
              if (item.owner) {
                if (item.owner.userName) {
                  owner = item.owner.userName;
                }
              }
              item['owner'] = owner;
              let deletedBy = '';
              if (item.deletedBy) {
                if (item.deletedBy.userName) {
                  deletedBy = item.deletedBy.userName;
                }
              }
              item['deletedBy'] = deletedBy;
              this.data.push(item);
            });
          } else if (page > 1) {
            this.loadData(page - 1);
          }
        }
      });
    },
    tablePageChange(page: number) {
      this.currentPage = page;
      console.log('aaaaaapage:', page);
      this.loading = true;
      console.log('wikiSpaceId:');
      console.log(this.wikiSpaceInfo.wikiSpaceId);
      this.loadData(page);
    },
    handerClean() {
      this.showCleanTip = true;
    },
    handerRefresh() {
      this.loadData(this.currentPage);
    },
    handerCleanTipCancel() {
      this.showCleanTip = false;
    },
    handerCleanTipOk() {
      this.showCleanTip = false;
      deletRecycleList([], this.wikiSpaceInfo.wikiSpaceId).
      then((result) => {
        console.dir(result);
        const { code } = result.data;
        if (code === 200) {
          this.$message.success({
            content: intl.$t("清空成功") });

          this.loadData(1);
        } else {
          this.$message.error({
            content: intl.$t("清空失败") });

        }
      }).
      catch((err) => {
        this.$message.error(intl.$t("网络错误，请重试"));
      });
    },
    timeStampToTime(timestamp: number) {
      var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      const { lang } = useI18n();
      const isChinese = lang.includes('cn');

      var Y = date.getFullYear() + (isChinese ? '年' : '');
      var M =
      (date.getMonth() + 1 < 10 ?
      '0' + (date.getMonth() + 1) :
      date.getMonth() + 1) + (isChinese ? '月' : '');
      var D =
      (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + (
      isChinese ? '日 ' : ' ');
      var h =
      (date.getHours() < 10 ?
      '0' + date.getHours() :
      date.getHours()) + ':';
      var m =
      date.getMinutes() < 10 ?
      '0' + date.getMinutes() :
      date.getMinutes();
      // var s = (date.getSeconds() < 10 ? '0'+(date.getSeconds()) : date.getSeconds());

      var nowTime = new Date();
      if (nowTime.getFullYear() == date.getFullYear()) {
        if (isChinese) {
          return M + D + h + m;
        } else {
          return M + '/' + D + h + m;
        }
      } else {
        if (isChinese) {
          return Y + M + D + h + m;
        } else {
          return M + '/' + D + '/' + Y + ' ' + h + m;
        }
      }
    } } };
</script>

<style lang="scss" scoped>
.trash_view {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-flow: row;
    box-sizing: border-box;

    .menu {
        box-sizing: border-box;
        padding: 24px 0;
        height: 100%;
        width: 210px;
        background: #fafafb;
        box-shadow: inset -1px 0 0 0 #e8e9eb;
        overflow: hidden;

        .header {
            padding: 0 8px;
            width: 100%;
            display: flex;
            flex-flow: row;
            align-items: center;
            justify-content: flex-start;

            .back-tip {
                display: flex;
                align-items: center;
                flex-flow: row;
                border-radius: 4px;
                width: 101px;
                height: 26px;
                padding-left: 8px;
                cursor: pointer;

                .header-title {
                    font-family: PingFangSC-Regular;
                    font-weight: 400;
                    font-size: 14px;
                    color: #3d4757;
                    letter-spacing: 0;
                    // margin: 0 73px 0 5px;
                    margin-left: 5px;
                }
            }

            .back-tip:hover {
                background-color: #eaebec;
            }

            .wiki-icon {
                width: 16px;
                height: 16px;
            }
        }

        .wiki-info {
            // padding: 23px 24px 10px;
            padding-left: 16px;
            padding-top: 24px;
            padding-bottom: 8px;
            padding-right: 16px;
            // width: 100%;
            display: flex;
            flex-flow: row;
            align-items: center;
            justify-content: flex-start;
            border-bottom: 1px solid #e8e9eb;

            span {
                letter-spacing: 0;
                font-family: PingFangSC-Regular;
                font-weight: 400;
                font-size: 14px;
                color: #3d4757;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
            }

            .wiki-space {
                width: 24px;
                height: 24px;
                margin-right: 8px;
            }
        }

        .wiki-trash {
            padding: 0 28px;
            margin-top: 23px;
            width: 100%;
            display: flex;
            flex-flow: row;
            align-items: center;
            justify-content: flex-start;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #3d4757;
            letter-spacing: 0;

            .wiki-space {
                width: 16px;
                height: 16px;
                margin-right: 8px;
            }
        }
    }

    .trash_content {
        display: flex;
        flex-flow: column;
        flex: 1;
        height: 100%;

        .trash_empty {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 90vh;

            img {
                width: 100px;
                height: 100px;
            }

            .trash_empty_tip {
                font-size: 14px;
                color: #a2a4b0;
                padding-left: 23px;
                padding-top: 10px;
            }
        }

        .toolbar {
            height: 54px;
            box-sizing: border-box;
            display: flex;
            flex-flow: row;
            justify-content: space-between;
            align-items: center;
            padding: 16px;
            border-bottom: 1px solid #e8e9eb;

            .toolbar_left {
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-family: PingFangSC-Medium;
                font-weight: 500;
                font-size: 16px;
                color: #121317;
                letter-spacing: 0;

                .wiki-menu-open {
                    margin-right: 21px;
                    width: 16px;
                    height: 16px;
                }
            }

            .toolbar_right {
                .wiki-button {
                    margin-left: 12px;
                    width: 80px;
                    height: 32px;
                    background: #ffffff;
                    border: 1px solid #e8e9ee;
                    border-radius: 8px;
                    font-family: PingFangSC-Medium;
                    font-weight: 500;
                    font-size: 14px;
                    color: #222329;
                    line-height: 20px;

                    img {
                        margin-left: 4px;
                        width: 12px;
                        height: 12px;
                    }
                }

                .wiki-button:hover {
                    color: #5a6cff;
                    border-color: #5a6cff;
                }

                .clear:hover {
                    img {
                        content: url(@/assets/img/trash/wiki-button-clear-hover.svg);
                    }
                }

                .refresh:hover {
                    img {
                        content: url(@/assets/img/trash/wiki-button-refresh-hover.svg);
                    }
                }
            }
        }

        .table {
            padding-top: 22px;
            overflow-y: scroll;
            flex: 1;
        }
    }
}
</style>

<style>
.wiki-table {
    .arco-table-th {
        background-color: #fafafa;
    }

    .arco-table-tr {
        height: 56px;
    }

    /* .arco-table-td {
      padding-left: 20px;
    } */

    .arco-table-tr:hover {
        cursor: pointer;

        .arco-table-td {
            background: #f4f6f9;
            /* padding-left: 40px; */
        }
    }

    .arco-table-td {
        background: #ffffff;
    }
}
</style>
